<div class="header-container">
    <a class="logo-container" href="#" (click)="navigateHome()" aria-label="Lamp Pole Banner Management Site">
        <img class="logo-img" [src]="logoPath" alt="City of Jacksonville logo" />
        <div class="logo">
            <div class="title">{{ title }}</div>
            <div class="subtitle">{{ subtitle }}</div>
        </div>
    </a>
    <div class="help-container">
        <button class="help-btn" [nbPopover]="helpTemplate" nbPopoverTrigger="click" #helpPopover="nbPopover">
            ?
        </button>

        <ng-template #helpTemplate>
            <div class="help-popover">
                <button class="popover-close" (click)="closePopover()">
                    ✕
                </button>
                <div class="help-title">For further assistance</div>

                <div class="help-body">
                    please contact Special Events:
                </div>

                <div class="help-contact">
                    <a href="mailto:eventpermit&#64;coj.net">eventpermit&#64;coj.net</a><br />
                    <a href="tel:9042555428">(904) 255-5428</a>
                </div>
            </div>
        </ng-template>
    </div>
</div>